module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-bank-02.fd0a0358.jpeg";